import React from "react";
import { Route } from "wouter";
import Header from "./components/header/Header";
import HomePage from "./components/homepage/Hompage";
import Solutions from "./components/solutions/Solutions";
import Industries from "./components/industries/Industries";
import Products from "./components/products/Products";
import Software from "./components/software/Software";
import BlogsContainer from "./components/blogs/BlogsContainer";
import ConatctUs from "./components/contact-us/ContactUs";
import Footer from "./components/footer/Footer";
import PrivacyPolicy from "./components/privacy_policy/PrivacyPolicy";
import TermsAndConditions from "./components/terms_and_conditions/TermsAndConditions";
import "./App.css";
// import { HelmetProvider } from "react-helmet-async";

const App = () => {
    const helmetContext = {};

    return (
        // <HelmetProvider context={helmetContext}>
        <main>
            <Header />
            <Route path="/" component={HomePage} />
            <Route path="/solution/:page" component={Solutions} />
            <Route path="/product/:page" component={Products} />
            <Route path="/gpon-software" component={Software} />
            <Route path="/industries/:page" component={Industries} />
            <Route path="/blogs" component={BlogsContainer} />
            <Route path="/contact" component={ConatctUs} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/terms-and-conditions" component={TermsAndConditions} />
            <Footer />
        </main>
        // </HelmetProvider>
    );
};

export default App;
